var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("login.title")))
      ]),
      _vm._v(" "),
      _c(
        "form-container",
        { attrs: { size: "small" } },
        [
          _c(
            "b-form-group",
            { attrs: { label: _vm.$t("login.email"), "label-for": "email" } },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'"
                  }
                ],
                attrs: {
                  id: "email",
                  name: "email",
                  type: "email",
                  disabled: _vm.isLoading,
                  "data-vv-as": _vm.$t("login.email")
                },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("email"),
                      expression: "errors.has('email')"
                    }
                  ],
                  staticClass: "form__error"
                },
                [_vm._v(_vm._s(_vm.errors.first("email")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("login.password"),
                "label-for": "password"
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  id: "password",
                  name: "password",
                  type: "password",
                  disabled: _vm.isLoading,
                  "data-vv-as": _vm.$t("login.password")
                },
                model: {
                  value: _vm.password,
                  callback: function($$v) {
                    _vm.password = $$v
                  },
                  expression: "password"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("password"),
                      expression: "errors.has('password')"
                    }
                  ],
                  staticClass: "form__error"
                },
                [_vm._v(_vm._s(_vm.errors.first("password")))]
              ),
              _vm._v(" "),
              _c(
                "b-link",
                {
                  staticClass: "reset-password-link",
                  attrs: { to: "/reset-password" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("login.resetPassword")) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isLoading
            ? _c(
                "b-button",
                {
                  attrs: {
                    disabled: !_vm.isValid || _vm.isLoading,
                    variant: "primary"
                  },
                  on: { click: _vm.login }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("login.performLogin")) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoading ? _c("loading-indicator") : _vm._e(),
          _vm._v(" "),
          _vm.errorMsg
            ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                _vm._v(_vm._s(_vm.errorMsg))
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dac4566", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dac4566","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginForm.vue
// module id = null
// module chunks = 